import { t } from 'i18next';
import * as yup from 'yup';

export const setUpAccountSchema = () =>
  yup.object().shape({
    firstName: yup
      .string()
      .trim()
      .label(t('labelFirstName'))
      .nullable()
      .required(t('errorFirstNameRequired')),
    lastName: yup
      .string()
      .trim()
      .label(t('labelLastName'))
      .nullable()
      .required(t('errorLastNameRequired')),
    company: yup
      .string()
      .trim()
      .label(t('labelCompany'))
      .nullable()
      .required(t('errorCompanyRequired')),
  });
